import { Logo } from "@/components/Logo";

export const AuthLayout = ({ title, subtitle, children, testid }) => {
  return (
    <div className="min-h-screen bg-cream flex flex-col items-center justify-center px-6 py-16" data-testid={testid}>
      <div className="w-full max-w-md cd-fade-in">
        <div className="flex justify-center mb-10">
          <Logo size={80} />
        </div>
        <div className="bg-white border border-sand rounded-sm p-8 sm:p-10">
          <h1 className="font-serif text-3xl font-light text-charcoal text-center">{title}</h1>
          {subtitle && (
            <p className="mt-3 text-sm text-charcoal/60 text-center leading-relaxed">{subtitle}</p>
          )}
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
};
